import React, { useEffect, useRef } from "react";

type Props = {
    src: string;
    style?: React.CSSProperties;
    loop?: boolean;
};

/**
 * Gatsby（SSG）ビルドでは React の `muted` prop がHTMLに出力されないため、
 * ブラウザの自動再生ポリシーにブロックされる。
 * useRef で DOM に直接 muted = true をセットすることで本番環境でも自動再生を保証する。
 */
const MutedVideo = ({ src, style, loop = true }: Props): JSX.Element => {
    const ref = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.muted = true;
            ref.current.play().catch(() => {
                // 自動再生がブロックされた場合は無視
            });
        }
    }, []);

    return (
        <video
            ref={ref}
            src={src}
            style={style}
            muted
            autoPlay
            loop={loop}
            playsInline
        />
    );
};

export default MutedVideo;
